<template>
    <div class="p-3">
        <!--PAIRED CHOICE-->
        <div
            v-if="
                goal &&
                    goal.parameters.method === 'paired' &&
                    goal.parameters.hasOwnProperty('items')
            "
        >
            <p class="text-primary font-weight-bold">
                {{ pairedChoices.length }}/{{ pairedChoicePairs.length }}
            </p>
            <div
                class="d-flex justify-content-between align-content-stretch"
                v-if="pairedChoices.length < pairedChoicePairs.length"
            >
                <div
                    class="w-100 m-2 py-5 btn btn-primary"
                    @click="
                        pairedChoice(
                            goal.parameters.items.find(
                                i => i === pairedChoicePairs[pairedChoices.length][0]
                            )
                        )
                    "
                >
                    {{
                        goal.parameters.items.find(
                            i => i === pairedChoicePairs[pairedChoices.length][0]
                        )
                    }}
                </div>
                <div
                    class="w-100 m-2 py-5 btn btn-primary"
                    @click="
                        pairedChoice(
                            goal.parameters.items.find(
                                i => i === pairedChoicePairs[pairedChoices.length][1]
                            )
                        )
                    "
                >
                    {{
                        goal.parameters.items.find(
                            i => i === pairedChoicePairs[pairedChoices.length][1]
                        )
                    }}
                </div>
            </div>
            <div class="" v-else="">
                <div class="w-100 m-2 py-3 btn btn-light" @click="pairedChoiceSaveAndFlip()">
                    Save and run flipped <small>(optional)</small>
                </div>
            </div>
        </div>

        <!--SINGLE CHOICE-->
        <div
            v-if="goal && goal.parameters.method === 'single' && goal.parameters.items.length"
            class="h-100"
        >
            <div class="">
                <div
                    v-for="(s, i) in goal.parameters.items"
                    class="w-100 m-2 btn"
                    :class="{
                        'btn-light': singleChoiceTimers[i],
                        'btn-primary': !singleChoiceTimers[i],
                        'btn-outline-primary': singleChoiceRunning === s,
                    }"
                    @click="singleChoiceTimers[i] ? null : singleChoiceTimerToggle(s, i)"
                >
                    <span class="d-flex justify-content-between alicce">
                        <span>{{ s }}</span>
                        <span>{{
                            singleChoiceRunning === s
                                ? singleChoiceDurationMinutes(singleChoiceElapsedTime)
                                : singleChoiceDurationMinutes(singleChoiceTimers[i])
                        }}</span>
                    </span>
                </div>
            </div>
        </div>

        <!--MSWO-->
        <div v-if="goal && goal.parameters.method === 'mswo' && goal.parameters.items.length">
            <div class="">
                <div
                    v-for="m in goal.parameters.items"
                    class="w-100 m-2 btn"
                    :class="{
                        'btn-light': mswoSelected.includes(m),
                        'btn-primary': !mswoSelected.includes(m),
                    }"
                    @click="!mswoSelected.includes(m) ? mswoSelect(m) : null"
                >
                    <span class="d-flex justify-content-between alicce">
                        <span
                            >{{ mswoSelected.includes(m) ? mswoSelected.indexOf(m) + 1 + " " : " "
                            }}{{ m }}</span
                        >
                    </span>
                </div>
            </div>
        </div>

        <!--MSW-->
        <div v-if="goal && goal.parameters.method === 'msw' && goal.parameters.items.length">
            <p class="text-primary font-weight-bold">Choices presented: {{ mswSelected.length }}</p>
            <div class="">
                <div
                    v-for="m in goal.parameters.items"
                    class="w-100 m-2 btn btn-primary"
                    @click="mswSelect(m)"
                >
                    <span class="d-flex justify-content-between alicce">
                        <span>{{ mswSelected.filter(s => m === s).length }}&nbsp;{{ m }}</span>
                    </span>
                </div>
            </div>
        </div>

        <!--FREE OPERANT-->
        <div
            v-if="goal && goal.parameters.method === 'free_operant' && goal.parameters.items.length"
        >
            <div class="">
                <div
                    v-for="(f, i) in goal.parameters.items"
                    class="w-100 m-2 btn btn-primary"
                    :class="{ 'btn-outline-primary': foChoiceRunning === f }"
                    @click="foChoiceTimerToggle(f, i)"
                >
                    <span class="d-flex justify-content-start alicce">
                        <span class="mr-2">{{ foChoiceInstances[i] }}</span>
                        <span>{{ f }}</span>
                        <span class="ml-auto">{{
                            foChoiceRunning === f
                                ? foChoiceDurationMinutes(foChoiceElapsedTime + foChoiceTimers[i])
                                : foChoiceDurationMinutes(foChoiceTimers[i])
                        }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PreferenceAssessment",
    props: ["goal", "date", "customization", "notesData"],
    data() {
        return {
            interval: null,
            currentTime: this.moment(),

            //PAIRED CHOICE:
            pairedChoiceItems: [],
            pairedChoicePairs: [],
            pairedChoices: [],
            pairedChoicesReport: {},
            saveAndFlip: false,

            //SINGLE CHOICE:
            singleChoiceStartTime: this.moment(),
            singleChoiceRunning: null,
            singleChoiceRunningLast: null,
            singleChoiceTimers: [],

            //MSWO:
            mswoSelected: [],

            //MSW:
            mswSelected: [],

            //FREE OPERANT:
            foChoiceStartTime: this.moment(),
            foChoiceRunning: null,
            foChoiceRunningLast: null,
            foChoiceLastDuration: null,
            foChoiceTimers: [],
            foChoiceInstances: [],

            //MOST SELECTED:
            selectedItems: [],
            topItem: null,
        };
    },
    created() {
        if (this.goal) {
            this.type = this.goal.parameters.method;
            this.interval = setInterval(this.updateCurrentTime, 1000);
            switch (this.goal.parameters.method) {
                case "paired":
                    this.pairedChoiceItems = this.goal.parameters.items;

                    this.pairedChoicePairs = this.getPairedChoiceCombinations(
                        this.pairedChoiceItems
                    );

                    this.flipIfSamePreviousChoicePairs();

                    break;
                case "single":
                    if (this.goal && this.goal.parameters.hasOwnProperty("items")) {
                        this.goal.parameters.items.forEach(() => {
                            this.singleChoiceTimers.push(0);
                        });
                    }
                    break;
                case "free_operant":
                    if (this.goal && this.goal.parameters.hasOwnProperty("items")) {
                        this.goal.parameters.items.forEach(() => {
                            this.foChoiceTimers.push(0);
                            this.foChoiceInstances.push(0);
                        });
                    }
                    break;
            }
        }
    },
    computed: {
        singleChoiceElapsedTime() {
            return this.currentTime.diff(this.singleChoiceStartTime, "seconds");
        },
        foChoiceElapsedTime() {
            return this.currentTime.diff(this.foChoiceStartTime, "seconds");
        },
    },
    methods: {
        undoAttempt() {
            switch (this.goal.parameters.method) {
                case "paired":
                    this.pairedChoiceUndo();
                    break;
                case "single":
                    if (!this.singleChoiceRunning) {
                        this.singleChoiceUndo();
                    }
                    break;
                case "msw":
                    this.mswUndo();
                    break;
                case "mswo":
                    this.mswoUndo();
                    break;
                case "free_operant":
                    if (!this.foChoiceRunning) {
                        this.foChoiceUndo();
                    }
                    break;
            }
        },
        reportResult(success) {
            this.$emit("saved", success);
            if (success) {
                this.$emit(
                    "close-tracker",
                    this.goal.title +
                        ": - " +
                        `The preferred choice was ${this.topItem} - ` +
                        this.notesData
                );
            }
        },
        saveTrackerData() {
            let data = {
                session_at: this.date
                    ? this.moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                    : this.moment().format("YYYY-MM-DD HH:mm:ss"),
                notes: this.notesData,
                data: {
                    type: "preference_assessment",
                    method: this.goal.parameters.method,
                },
            };
            switch (this.goal.parameters.method) {
                case "single":
                    data.data.items = this.singleChoiceResults();
                    break;
                case "paired":
                    this.pairedChoiceItems.forEach(item => {
                        let entry = {};
                        entry.presented =
                            this.pairedChoices.filter(p => p.left === item).length +
                            this.pairedChoices.filter(p => p.right === item).length;
                        entry.selected = this.pairedChoices.filter(p => p.selected === item).length;
                        this.pairedChoicesReport[item] = entry;
                    });
                    let maxSelected = 0;
                    Object.keys(this.pairedChoicesReport).forEach(k => {
                        if (this.pairedChoicesReport[k].selected > maxSelected || !maxSelected) {
                            maxSelected = this.pairedChoicesReport[k].selected;
                            this.topItem = k;
                        }
                    });
                    data.data.items = this.pairedChoicesReport;
                    data.data.pairedChoicePairs = this.pairedChoicePairs;
                    break;
                case "msw":
                    data.data.items = this.mswResults();
                    break;
                case "mswo":
                    data.data.items = this.mswoResults();
                    break;
                case "free_operant":
                    data.data.items = this.foChoiceResults();
                    break;
            }
            axios
                .post(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`, data)
                .then(r => {
                    this.saving = false;
                    if (!this.saveAndFlip) {
                        this.reportResult(true);
                    } else {
                        this.saveAndFlip = false;
                    }
                })
                .catch(error => {
                    this.$emit("save-draft", { error, data });
                    this.reportResult(false);
                    this.$swal({
                        title: "Error!",
                        text: "An error occurred while saving.",
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    console.error(error);
                });
        },
        updateCurrentTime() {
            this.currentTime = this.moment();
        },

        // PAIRED CHOICE
        /**
         * If there is a previous data tracker, and its pairedChoicePairs are the same as these,
         * returns true.
         */

        flipIfSamePreviousChoicePairs() {
            self = this;
            axios
                .get(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`, {
                    params: {
                        sort: [
                            {
                                key: "session_at",
                                direction: "DESC",
                            },
                        ],
                        limit: 1,
                    },
                })
                .then(r => {
                    if (r.data.data.length && r.data.data[0].data.pairedChoicePairs) {
                        if (
                            JSON.stringify(r.data.data[0].data.pairedChoicePairs) ===
                            JSON.stringify(this.pairedChoicePairs)
                        ) {
                            this.pairedChoiceFlip();
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        },
        /**
         * Returns all relevant combinations of the array of items.
         * Input param is an array of items, k is length of output set (i.e. 2 = pairs)
         */
        getPairedChoiceCombinations(set, k = 2) {
            if (k > set.length || k <= 0) {
                return [];
            }
            if (k === set.length) {
                return [set];
            }
            const combs = [];
            if (k === 1) {
                for (let i = 0; i < set.length; i++) {
                    combs.push([set[i]]);
                }
                return combs;
            }
            for (let i = 0; i < set.length - k + 1; i++) {
                const head = set.slice(i, i + 1);
                const tailcombs = this.getPairedChoiceCombinations(set.slice(i + 1), k - 1);
                for (let j = 0; j < tailcombs.length; j++) {
                    combs.push(head.concat(tailcombs[j]));
                }
            }
            // Makes sure items are not repeated consecutively on the same side
            for (let i = 1; i < combs.length; i++) {
                if (combs[i][0] == combs[i - 1][0] || combs[i][1] == combs[i - 1][1]) {
                    let temp = combs[i][0];
                    combs[i][0] = combs[i][1];
                    combs[i][1] = temp;
                }
            }
            return combs;
        },

        pairedChoice(selected) {
            this.pairedChoices.push({
                left: this.pairedChoicePairs[this.pairedChoices.length][0],
                right: this.pairedChoicePairs[this.pairedChoices.length][1],
                selected: selected,
            });
            this.selectedItems.push(selected);
        },
        pairedChoiceUndo() {
            this.pairedChoices.pop();
        },
        pairedChoiceFlip() {
            this.pairedChoicePairs.reverse();
            this.pairedChoicePairs.forEach(p => p.reverse());
        },
        pairedChoiceSaveAndFlip() {
            this.saveAndFlip = true;
            this.saveTrackerData();
            this.pairedChoiceFlip();
            this.pairedChoices = [];
        },

        // SINGLE CHOICE
        singleChoiceDurationMinutes(duration) {
            let s = duration % 60;
            let m = Math.floor(duration / 60);
            return m.toString() + ":" + ("0" + s).slice(-2);
        },
        singleChoiceTimerToggle(item, index) {
            if (this.singleChoiceRunning === item) {
                this.singleChoiceTimers[index] = this.singleChoiceElapsedTime;
                this.singleChoiceRunning = null;
            } else {
                this.singleChoiceStartTime = this.moment();
                this.singleChoiceRunning = item;
                this.singleChoiceRunningLast = item;
            }
        },
        singleChoiceUndo() {
            this.singleChoiceRunning = this.singleChoiceRunningLast;
            let i = this.goal.parameters.items.indexOf(this.singleChoiceRunningLast);
            this.singleChoiceTimers[i] = 0;
        },
        singleChoiceResults() {
            let items = {};
            this.goal.parameters.items.forEach((item, i) => {
                items[item] = { duration: this.singleChoiceTimers[i] };
            });
            let maxDuration = 0;
            Object.keys(items).forEach(k => {
                if (items[k].duration > maxDuration || !maxDuration) {
                    maxDuration = items[k].duration;
                    this.topItem = k;
                }
            });
            return items;
        },

        // MSWO
        mswoSelect(item) {
            this.mswoSelected.push(item);
        },
        mswoUndo() {
            this.mswoSelected.pop();
        },
        mswoResults() {
            let items = {};
            this.topItem = this.mswoSelected[0];
            this.goal.parameters.items.forEach((item, i) => {
                items[item] = { points: this.mswoSelected.indexOf(item) + 1 };
            });
            return items;
        },
        // MSW
        mswSelect(item) {
            this.mswSelected.push(item);
        },
        mswUndo() {
            this.mswSelected.pop();
        },
        mswResults() {
            let items = {};
            this.goal.parameters.items.forEach((item, i) => {
                items[item] = {
                    selected: this.mswSelected.filter(m => m === item).length,
                    presented: this.mswSelected.length,
                };
            });
            let maxSelected = 0;
            Object.keys(items).forEach(k => {
                if (items[k].selected > maxSelected || !maxSelected) {
                    maxSelected = items[k].selected;
                    this.topItem = k;
                }
            });
            return items;
        },
        // FREE CHOICE
        foChoiceDurationMinutes(duration) {
            let s = duration % 60;
            let m = Math.floor(duration / 60);
            return m.toString() + ":" + ("0" + s).slice(-2);
        },
        foChoiceTimerToggle(item, index) {
            if (this.foChoiceRunning === item) {
                this.foChoiceTimers[index] += this.foChoiceElapsedTime;
                this.foChoiceLastDuration = this.foChoiceElapsedTime;
                this.foChoiceRunning = null;
            } else {
                if (this.foChoiceRunning) {
                    let prevIndex = this.goal.parameters.items.indexOf(this.foChoiceRunning);
                    this.foChoiceTimers[prevIndex] += this.foChoiceElapsedTime;
                    this.foChoiceLastDuration = this.foChoiceElapsedTime;
                    this.foChoiceRunning = null;
                }
                this.foChoiceInstances[index]++;
                this.foChoiceStartTime = this.moment();
                this.foChoiceRunning = item;
                this.foChoiceRunningLast = item;
            }
        },
        foChoiceUndo() {
            this.foChoiceRunning = this.foChoiceRunningLast;
            let i = this.goal.parameters.items.indexOf(this.foChoiceRunningLast);
            this.foChoiceTimers[i] -= this.foChoiceLastDuration;
        },
        foChoiceResults() {
            let items = {};
            this.goal.parameters.items.forEach((item, i) => {
                items[item] = {
                    duration: this.foChoiceTimers[i],
                    selected: this.foChoiceInstances[i],
                };
            });
            let maxDuration = 0;
            Object.keys(items).forEach(k => {
                if (items[k].duration > maxDuration || !maxDuration) {
                    maxDuration = items[k].duration;
                    this.topItem = k;
                }
            });
            return items;
        },
    },
};
</script>
